import { TermiiClient } from "./client";

export default TermiiClient;
export type * from "./types";
